var _desc, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction-Pop-Income-2",
    transform: "translate(-246.000000, -441.000000)",
    fill: "#FF8B8B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(26.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    transform: "translate(200.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank",
    transform: "translate(20.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5444336,3.7721354 L8,0 L0.4555664,3.7721354 C0.176432267,3.91178387 0,4.1972656 0,4.5091146 C0,4.9645182 0.368977867,5.33333333 0.824056,5.33333333 L15.175944,5.33333333 C15.6310221,5.33333333 16,4.9645182 16,4.5091146 C16,4.1972656 15.8235677,3.91178387 15.5444336,3.7721354 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.66666667 12 0 14.6666667 0 16 16 16 16 14.6666667 13.3333333 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.3333333 5.33333333 10.6666667 5.33333333 10.6666667 12 9.33333333 12 9.33333333 5.33333333 6.66666667 5.33333333 6.66666667 12 5.33333333 12 5.33333333 5.33333333 2.66666667 5.33333333 2.66666667 12 13.3333333 12"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.b6a136a647c0ef67f3b4acec69a4a32d.svg";
export { ForwardRef as ReactComponent };